/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AssessmentViewQueryComment extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AssessmentViewQueryComment");
    }

    getFixupPrototypeFunction() { return AssessmentViewQueryComment.fixupPrototype; }

    static newInstance(model: Partial<AssessmentViewQueryComment>): AssessmentViewQueryComment {
        let obj = Object.assign(new AssessmentViewQueryComment(), model);
        AssessmentViewQueryComment.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AssessmentViewQueryComment>): AssessmentViewQueryComment {
        if (!model) return null;
        return AssessmentViewQueryComment.newInstance(<AssessmentViewQueryComment> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AssessmentViewQueryComment) {
        if (!obj) return;

        models.AssessmentViewQueryComment.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AssessmentViewQueryComment): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AssessmentViewQueryComment.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * User id who commented
     */
    comments: Array<string>;

}
